<!--  -->
<template>
  <div>
    <div>
      <el-tabs value="first">
        <el-tab-pane label="关键词回复" name="first">
          <div class="header-select">
            <el-form inline>
              <el-form-item label="公众号选择：">
                <el-select v-model="keywordsAppId" @change="handleChangeKeywordList">
                  <el-option
                    v-for="item in keywordsAppIdsOptions"
                    :key="item.value"
                    :label="item.app_name"
                    :value="item.app_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 20px; float: right">
            <el-button type="primary" @click="handleAddReply" :disabled="!keywordsAppId">
              新建回复
            </el-button>
          </div>
          <el-table :data="keywordsDataList" v-loading="tableLoading">
            <el-table-column label="规则名称" prop="rule_name"></el-table-column>
            <el-table-column label="关键词">
              <template slot-scope="scope">
                {{ scope.row.keywords ? scope.row.keywords.split(',').join(' | ') : '' }}
              </template>
            </el-table-column>
            <!--            <el-table-column-->
            <!--              label="回复内容"-->
            <!--              prop="content"-->
            <!--              show-overflow-tooltip-->
            <!--              width="280"-->
            <!--            ></el-table-column>-->
            <el-table-column label="回复内容" show-overflow-tooltip width="280">
              <template slot-scope="scope">
                {{ scope.row.content[0] }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleDelect(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              :page-sizes="g_pageSizesConfig"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_index"
              :page-size="page_size"
              layout="total,sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="收到消息回复" name="second">
          <div v-loading="msgLoading">
            <div class="header-select">
              <el-form inline>
                <el-form-item label="公众号选择：">
                  <el-select v-model="repMsgAppId" @change="handleGetMsg">
                    <el-option
                      v-for="item in keywordsAppIdsOptions"
                      :key="item.value"
                      :label="item.app_name"
                      :value="item.app_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="margin-top: 20px">
              <el-form>
                <el-form-item label="回复内容：">
                  <el-input
                    type="textarea"
                    class="reply-content"
                    v-model="receivedReplyContent"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="handleDelectRevice" :disabled="!receivedReplyContent">
                    删除回复
                  </el-button>
                  <el-button type="primary" @click="handleReceiveReply">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="被关注回复" name="third">
          <div v-loading="focusMsgLoading">
            <div class="header-select">
              <el-form inline>
                <el-form-item label="公众号选择：">
                  <el-select v-model="focusMsgAppId" @change="handleGetFocusMsg">
                    <el-option
                      v-for="item in keywordsAppIdsOptions"
                      :key="item.value"
                      :label="item.app_name"
                      :value="item.app_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="margin-top: 20px">
              <el-form>
                <el-form-item label="回复内容：">
                  <el-input
                    type="textarea"
                    class="reply-content"
                    v-model="focusReplyContent"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="handleDelectFocus" :disabled="!focusReplyContent">
                    删除回复
                  </el-button>
                  <el-button type="primary" @click="handleFocusReply">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 关键词回复详情 -->
      <el-dialog title="详情" :visible.sync="dialogFormVisible" center>
        <el-form v-loading="dialogLoading">
          <el-form-item label="规则名称：" label-width="130px">
            {{ keywordsDetail.rule_name }}
          </el-form-item>
          <el-form-item label="关键词：" label-width="130px">
            {{ keywordsDetail.keywords ? keywordsDetail.keywords.split(',').join(' | ') : '' }}
          </el-form-item>
          <!--          <el-form-item label="回复内容：">-->
          <!--            {{ keywordsDetail.content }}-->
          <!--          </el-form-item>-->
          <el-form-item
            label="回复文字："
            v-for="(text, index) in keywordsDetail.content"
            :key="index"
            label-width="130px"
          >
            {{ text }}
          </el-form-item>
          <el-form-item
            label="回复文章："
            label-width="130px"
            v-for="(art, index) in keywordsDetail.article"
            :key="index"
          >
            <img :src="art.cover_url" alt="" style="width: 200px; height: 130px" />
            <div>文章标题：{{ art.title }}</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GetReplyRuleList,
  DelReplyRule,
  EditDefaultRule,
  EditWelcom,
  GetWelcom,
  DelWelcom,
  GetReplyRule,
} from '@/api/messageManagement.js';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      msgLoading: false,
      focusMsgLoading: false,
      dialogFormVisible: false,
      dialogLoading: false,
      tableLoading: false,
      keywordsAppId: '',
      repMsgAppId: '',
      focusMsgAppId: '',
      page_index: 1,
      page_size: this.g_pageSizeDefault,
      total: 0,
      keywordsDataList: [], // 关键词回复数据列表
      keywordsDetail: {},
      receivedReplyContent: '', // 收到消息回复内容
      focusReplyContent: '', // 被关注回复
    };
  },
  computed: {
    keywordsAppIdsOptions() {
      return this.$store.getters['user/getPublishList'];
    },
  },
  async created() {
    this.page_size = this.g_pageSizeDefault;
    await this.getManagerLogin();
    // this.keywordsAppId = this.keywordsAppIdsOptions ? this.keywordsAppIdsOptions[0].app_id : '';
    this.repMsgAppId = this.keywordsAppIdsOptions ? this.keywordsAppIdsOptions[0].app_id : '';
    this.focusMsgAppId = this.keywordsAppIdsOptions ? this.keywordsAppIdsOptions[0].app_id : '';
    // this.handleSelectAppId();
    this.handleGetMsg();
    this.handleGetFocusMsg();
    if (this.$route.query.app_id) {
      this.keywordsAppId = this.$route.query.app_id;
      this.handleSelectAppId();
    } else {
      this.keywordsAppId = this.keywordsAppIdsOptions ? this.keywordsAppIdsOptions[0].app_id : '';
      this.handleSelectAppId();
    }
  },
  methods: {
    handleDelectFocus() {
      // 删除被关注消息的回复
      if (this.focusMsgAppId === '') {
        this.$message.error('请选择公众号');
        return false;
      }
      this.$confirm('删除后，关注该公众号的用户将不再接收该回复，确定删除？')
        .then(() => {
          DelWelcom({ app_id: this.focusMsgAppId, rule_type: 1 })
            .then(() => {
              this.focusReplyContent = '';
              this.$message.success('删除成功');
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
        .catch(() => {});
    },
    handleDelectRevice() {
      // 删除收到消息的回复
      if (this.repMsgAppId === '') {
        this.$message.error('请选择公众号');
      } else {
        this.$confirm('删除后，关注该公众号的用户将不再接收该回复，确定删除？')
          .then(() => {
            DelWelcom({ app_id: this.repMsgAppId, rule_type: 2 })
              .then(() => {
                this.receivedReplyContent = '';
                this.$message.success('删除成功');
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          })
          .catch(() => {});
      }
    },
    handleFocusReply() {
      // 编辑被关注回复
      if (this.focusMsgAppId === '') {
        this.$message.error('请选择公众号');
        return false;
      }
      EditWelcom({ app_id: this.focusMsgAppId, content: this.focusReplyContent })
        .then(() => {
          this.$message.success('保存成功');
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleReceiveReply() {
      // 编辑收到消息回复
      if (this.repMsgAppId === '') {
        this.$message.error('请选择公众号');
        return false;
      }
      EditDefaultRule({ app_id: this.repMsgAppId, content: this.receivedReplyContent })
        .then(() => {
          this.$message.success('保存成功');
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleDetail(row) {
      this.dialogFormVisible = true;
      this.dialogLoading = true;
      GetReplyRule({ rule_id: row.rule_id }).then(({ rule }) => {
        this.keywordsDetail = rule;
        this.loading = false;
        this.dialogLoading = false;
      });

      this.keywordsDetail = row;
    },
    handleEdit(row) {
      this.g_tourl(
        `/saas/addAutoReply.html?app_id=${this.keywordsAppId}&rule_id=${row.rule_id}&type=edit`,
      );
    },
    handleDelect(row) {
      this.$confirm('确认删除吗')
        .then(() => {
          DelReplyRule({ rule_id: row.rule_id })
            .then(() => {
              this.$message.success('删除成功');
              this.handleSelectAppId();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
        .catch(() => {});
    },
    ...mapActions('user', ['getManagerLogin']),
    handleAddReply() {
      this.g_tourl(`/saas/addAutoReply.html?app_id=${this.keywordsAppId}&type=add`);
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.handleSelectAppId();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.handleSelectAppId();
    },
    handleSelectAppId() {
      this.tableLoading = true;
      GetReplyRuleList({
        app_id: this.keywordsAppId,
        page_index: this.page_index,
        page_size: this.page_size,
      })
        .then((res) => {
          // console.log(res);
          this.keywordsDataList = res.rules;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    handleGetMsg() {
      if (this.repMsgAppId === '') {
        this.$message.error('请选择公众号');
        return false;
      }
      this.msgLoading = true;
      GetWelcom({ app_id: this.repMsgAppId, rule_type: 2 })
        .then((res) => {
          this.receivedReplyContent = res.content;
          this.msgLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleGetFocusMsg() {
      if (this.focusMsgAppId === '') {
        this.$message.error('请选择公众号');
        return false;
      }
      this.focusMsgLoading = true;
      GetWelcom({ app_id: this.focusMsgAppId, rule_type: 1 })
        .then((res) => {
          this.focusReplyContent = res.content;
          this.focusMsgLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleChangeKeywordList() {
      this.page_index = 1;
      this.handleSelectAppId();
    },
    // getContent(row) {
    //   // 只有文章
    //   if (row.content.length === 0) {
    //     return `${row.article.length} 个文章`;
    //   }
    //   // 只有文字
    //   if (row.article.length === 0) {
    //     return `${row.content.length} 段文字`;
    //   }
    //   // 都有
    //   return `${row.content.length} 段文字,${row.article.length} 个文章`;
    // },
  },
};
</script>

<style lang="scss" scoped>
.header-select {
  height: 70px;
  border-bottom: 1px solid #edeff2;
  margin-top: 22px;
}
.pagination {
  margin-top: 20px;
  float: right;
}
::v-deep.reply-content {
  width: 600px;
  height: 230px;
  .el-textarea__inner {
    height: 230px;
    resize: none;
  }
}
</style>
